import { Card, Stack, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Strings } from '@app/constants';
import { Scrollbar } from '@app/components';
import { MangerProjectOverview } from './manger-project-overview';
import { ManagerHolidayAndProject } from './manager-holiday-and-project';
import { MangerLeavesPage } from './manager-leaves-page';
import { MangerRequestedApprovedLeaves } from './manger-requested-approved-leaves';
import { MangerAssetsAndTasksPage } from './manger-assets-and-tasks-page';
import { UserCard } from '@app/components/card';
import { useRequestState } from '@app/hooks';
import {
  getDashboardData,
  getTaskAssignment,
  selectDashboardState,
  selectGetTaskAssignmentState,
} from '@app/modules/dashboard';
import { getDurationDisplay } from '@app/configs';

const ManagerDashboardPage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  const { data } = useRequestState({
    stateSelector: selectDashboardState,
    errorShown: true,
  });

  useEffect(() => {
    dispatch(getTaskAssignment());
  }, [dispatch]);

  const { data: taskAssignment } = useRequestState({
    stateSelector: selectGetTaskAssignmentState,
    errorShown: true,
  });

  const fullName: string =
    (String(data?.userForDashboard?.firstName) ?? '') +
    ' ' +
    (String(data?.userForDashboard?.lastName) ?? '');

  return (
    <>
      <Scrollbar>
        <Stack flexDirection={{ sm: 'column', md: 'row' }} mt={2}>
          <Card
            sx={{
              ml: { md: 2, xs: 1 },
              mr: { xs: 1, md: 0 },
              mb: 2,
              width: { md: '60%', sm: '96%' },
              borderRadius: '5px',
              backgroundImage: 'url(/assets/images/dashboard-background.png)',
              backgroundSize: 'auto',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          >
            <Stack fontSize={18} fontWeight={700} m={'20px 0px 15px 20px'}>
              {Strings.common.welcomeBackCaption(fullName)}
            </Stack>
            <Stack direction={'row'} mb={1} mr={3}>
              <Stack
                width={'400px'}
                m={'15px 0px 20px 20px'}
                color={theme.palette.grey[600]}
                fontSize={14}
              >
                {Strings.dashboard.caption}
              </Stack>
              <Stack justifyContent="center" display={{ xs: 'none', md: 'inline' }} mt={-6}>
                <img
                  src={'/assets/images/dashboard-icon.png'}
                  style={{
                    objectFit: 'contain',
                    height: '200px',
                    width: '200px',
                    alignItems: 'center',
                  }}
                />
              </Stack>
            </Stack>
          </Card>

          <Stack sx={{ width: { md: '40%', xs: '98%' } }} mr={{ md: 2, xs: 1 }}>
            <Stack direction={{ md: 'row', xs: 'row' }} width={{ xs: '100%' }}>
              <UserCard
                title={Strings.dashboard.employeeId}
                value={data?.userForDashboard?.userIdString}
                iconImg="ic_employeeId"
                width={{ md: '100%', xs: '50%' }}
              />
              <UserCard
                title={Strings.dashboard.workedFor}
                value={getDurationDisplay(data?.workedFor)}
                iconImg="ic_workedFor"
                width={{ md: '100%', xs: '50%' }}
              />
            </Stack>

            <Stack flexDirection={{ md: 'row', xs: 'row' }}>
              <UserCard
                title={Strings.dashboard.department}
                iconImg="ic_department"
                workedFor={data?.userForDashboard?.department}
                width={{ md: '100%', xs: '50%' }}
              />
              <UserCard
                title={Strings.dashboard.designation}
                workedFor={data?.userForDashboard?.designation}
                iconImg="ic_designation"
                width={{ md: '100%', xs: '50%' }}
              />
            </Stack>
          </Stack>
        </Stack>
        <MangerRequestedApprovedLeaves data={data} />
        <ManagerHolidayAndProject data={data} />
        <MangerProjectOverview data={data} />
        <MangerAssetsAndTasksPage data={data} taskAssignment={taskAssignment} />
        <MangerLeavesPage data={data} />
      </Scrollbar>
    </>
  );
};

export { ManagerDashboardPage };
